import React from 'react'
import Icon from 'react-fa'
import {t} from '../helpers/translate'
import {redirectIfNotLoggedIn, getAccessLevel, checkSchool, isAgent} from '../helpers/access'
import AgentDashboard from './AgentDashboard';
const config = require('config');

class LandingPage extends React.Component {

  constructor(props) {

    if(!("config" in sessionStorage)) {
      window.location.reload();
    }

    redirectIfNotLoggedIn();
    super(props);
    this.state = {}
  }

  getTileIcon(tile) {
  	return tile.icon;
  }

  getTileLink(tile){
    if(tile.custom_link){
      return tile.custom_link.replace('agentcode', sessionStorage.getItem('csr_token'));
    }

    return tile.link;
  }

  getTileTarget(tile){
    return tile.custom_link ? "_blank" : '';
  }

  renderTile(tile) {
    return <div className="landing-page-tile-layout row">
      <a href={this.getTileLink(tile)} className="col-xs-6 col-sm-4">
        <div className="col-sm-12 landing-page-tile">
          <div className="col-sm-2 landing-tile-icon">
            <Icon name={tile.icon} size="2x" />
          </div>
          <div className="col-sm-10 landing-tile-text">
            {t(tile.label)}
          </div>
        </div>
      </a>
    </div>
  }

  getPageTitle(title) {
    return title || config.default.landing[sessionStorage.getItem('org')].titles[getAccessLevel()];
  }

  render() {
  	const orgConfig = config.default.landing[sessionStorage.getItem('org')]
  	const tiles = config.default.landing.tiles
  	const authlevel = getAccessLevel()

    if (isAgent('ingle')) {
      return <AgentDashboard userName={sessionStorage.getItem('first_name') || ''} allowedTiles={orgConfig.tiles[authlevel]} />;
    }

    return (
      <div className={`container ${isAgent('ingle') && 'category-wrapper'}`}>
        <div className="text-center bg-inherit">
          <h2 className="page-title">
            {`${'Hello '}${sessionStorage.getItem('first_name')}, ${t('Welcome to the')} ${this.getPageTitle(orgConfig.title)} ${t('Insurance Dashboard')}`}
          </h2>
          <div className={`row landing-page-layout ${isAgent('ingle') && 'agent-margin'}`}>
            {orgConfig.tiles[authlevel].map((tile, i) =>
             this.renderTile(tiles[tile], i)
            )}
          </div>
        </div>
      </div>
    );
  }
}
LandingPage.displayName = 'Homepage';
export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/Landing.js